'use strict';

var $d = require('../dependency');
var $u = require('../utilities');
var $c = require('../config');

var _ = $d._;
var moment = $d.moment;

var arrayReject = $c.rejectFields;

exports.updateChartModelData = updateChartModelData;

function updateChartModelData(context, config, next) {
    var chartData = context.chartData,
        dataAvailabilityCounter = 0,
        totalValueGraphCount = null,
        modelData = {};

    var subTotal = 0, viewModelFields, fieldData, permittedField;

    viewModelFields = config.dataSeriesFields || config.modelFieldKeys;

    _.forEach(viewModelFields, function (field) {
        fieldData = chartData[field];
        if (_.isArray(fieldData) && fieldData.length && !$u.charts.allEqualElemArray(fieldData, null)) {
            dataAvailabilityCounter++;
        } else if (_.isObject(fieldData) && !(_.keys(fieldData).length) && !$u.charts.allEqualElemArray(_.keys(fieldData), null)) {
            dataAvailabilityCounter++;
        }
    });

    //taking each field in the chartdata array and storing them in model data object.
    _.forEach(viewModelFields, function (field) {
        modelData[field] = chartData[field];
        //if model data is an array
        if (_.isArray(modelData[field])) {
            if (arrayReject.indexOf(field) == -1) {
                subTotal += _.reduce(modelData[field], function (sum, value) {
                    if (value === null) {
                        return sum + 0;
                    } else if (_.isNumber(value.y)) {
                        return sum + Math.abs(value.y);
                    } else if (_.isArray(value)) {
                        return sum + value[1];
                    } else {
                        return sum + Math.abs(value);
                    }
                }, 0);
            }
        }
        //if model data is an object (In case of brand and store loyalty pie charts)
        else if (_.isObject(modelData[field])) {
            _.forEach(modelData[field], function (value) {
                subTotal += Math.abs(value);
            });
        }
    });

    if (config.dataSeriesFields) {
        permittedField = config.dataSeriesFields[0];
    }

    if (dataAvailabilityCounter === 0) {
        totalValueGraphCount = null;
    } else if (dataAvailabilityCounter === 1 &&
        (_.isArray(chartData.timestamp) && chartData.timestamp.length)
    ) {
        totalValueGraphCount = null;
    } else if (context.zeroDataFlag) {
        totalValueGraphCount = null;
    } else {
        totalValueGraphCount = subTotal;
    }

    // will change it with granuality;
    modelData.__duration = context.durationFilterValue;
    modelData.__granularity = context.granularity;
    modelData.i18n = context.i18n;
    modelData._env = context._env;

    context.totalValueGraphCount = totalValueGraphCount;
    context.modelData = modelData;
    context.dataAvailabilityCounter = dataAvailabilityCounter;
    modelData.__generationDateString = getGenerationDateString(context);

    next();
}

/**
 * 
 * 
 * @param  {Object} context The context
 * @returns {Object} Object containing start-time and end-time as per druid query
 */
function getIntervals(context) {
    var intervalParts,
        intervals,
        interval = (
            context &&
            context.intervals &&
            context.intervals[0] &&
            context.intervals[0][0]
        );
    if (interval) {
        intervalParts = interval.split('/');
        intervals = {
            startTime: intervalParts[0],
            endTime: intervalParts[1]
        };
    }

    return intervals;
}

function getGenerationDateString(context) {
    var dateFilter,
        dateFormat = 'DD MMM YY',
        modelData = context.modelData,
        // extracting intervals out of context
        intervals = getIntervals(context),
        generationDateString = '',
        durationFilter = _.find(context.filter, { id: 'duration' }),
        dateFilter = _.find(context.filter, { id: 'date' });

    if (durationFilter) {
        if (modelData.timestamp && modelData.timestamp.length) {
            // For timeseries charts
            var len = modelData.timestamp.length,
                convertorFn = getConvertor(
                    context.durationFilterValue, context.granularity
                );

            generationDateString = (
                moment.utc(modelData.timestamp[0]).format(dateFormat) +
                ' - ' +
                convertorFn(moment.utc(modelData.timestamp[len - 1]))
                    .format(dateFormat)
            );
        } else if (intervals) {
            // For TopN charts
            generationDateString = (
                moment.utc(intervals.startTime).format(dateFormat) +
                ' - ' +
                moment.utc(intervals.endTime).format(dateFormat)
            );
        }
    } else if (dateFilter) {
        if (intervals) {
            // This works only for SERVER
            generationDateString = (
                ' As on ' + moment.utc(intervals.endTime).format(dateFormat)
            );
        }
    }

    return generationDateString;
}

function getConvertor(durationFilterValue, granularity) {
    var lastDateConvertors = {
        basic: {
            week: noDateChange,
            month: noDateChange,
            quarter: addSixDays,
            year: toLastDayOfMonth,
            thisMonth: noDateChange
        },
        custom: {
            day: noDateChange,
            P1W: addSixDays,
            P1M: toLastDayOfMonth
        }
    };
    var convertorFn;

    if ('custom' !== durationFilterValue) {
        convertorFn = lastDateConvertors.basic[durationFilterValue];
    } else {
        convertorFn = lastDateConvertors.custom[
            granularity.period || granularity
        ];
    }

    return convertorFn;
}

/**
 * @param  {Moment Object} moment Passed moment object
 */
function noDateChange(moment) {
    return moment;
};

function addSixDays(moment) {
    moment.add(6, 'days');
    return moment;
}

function toLastDayOfMonth(moment) {
    moment.endOf('month');
    return moment;
}